export interface Article {
  id: string;
  slug: string;
  title: string;
  summary: string;
  category: string;
  categorySlug: string;
  tag: string;
  date: string;
  readTime: string;
  cover: string;
  content: string[];
}

export const articles: Article[] = [
  {
    id: 'a1',
    slug: 'how-to-tell-official',
    title: '如何一眼识别一部韩漫是否为正版渠道',
    summary: '盗版站和正版渠道的区别其实很明显。掌握这几个判断技巧，追更路上不再踩坑。',
    category: '追更指南',
    categorySlug: 'guide',
    tag: '防坑指南',
    date: '2026.08.12',
    readTime: '6 分钟',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20Korean%20webtoon%20illustration%20of%20a%20magnifying%20glass%20over%20open%20comic%20pages%20on%20a%20desk%2C%20warm%20cream%20and%20coral%20color%20palette%2C%20clean%20manga%20lineart%2C%20informative%20editorial%20illustration%2C%20high%20detail%20digital%20art&width=1200&height=760&seq=art-identify-2026&orientation=landscape',
    content: [
      '市面上韩漫网站很多，但真正获得官方授权、为正版韩漫大全收录的渠道屈指可数。学会判断，是每一位读者保护作品与作者的第一步。',
      '首先，看平台是否明确标注“官方授权”或“正版”标识，并能在平台页脚找到版权方的正式授权说明。真正的正版平台会大大方方公开授权关系，而不是遮遮掩掩。',
      '其次，观察更新方式与画质。正版平台更新稳定、图片高清、翻译流畅，且会显示官方章节编号与发布日期；盗版站常出现画质模糊、章节错乱、弹窗广告泛滥等问题。',
      '最后，留意付费与版权声明。正版平台会清晰说明付费规则，并尊重作者版权；而那些要求你安装来路不明插件、或反复跳转广告的站点，基本可以断定并非正版韩漫渠道。',
      '在正版韩漫大全，我们只收录公开标注授权关系的官方渠道，并持续更新各平台的正版作品清单，让你一键直达、安心追更。',
    ],
  },
  {
    id: 'a2',
    slug: 'official-way-to-read',
    title: '正版韩漫追更的正确打开方式',
    summary: '从注册到追更，一份关于如何在官方正版渠道顺畅追韩漫的完整操作指南。',
    category: '追更指南',
    categorySlug: 'guide',
    tag: '新手入门',
    date: '2026.08.06',
    readTime: '5 分钟',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20Korean%20webtoon%20illustration%20of%20a%20reader%20holding%20a%20phone%20showing%20comic%20pages%20with%20a%20cup%20of%20coffee%2C%20teal%20and%20cream%20color%20palette%2C%20cozy%20reading%20atmosphere%2C%20clean%20manga%20lineart%2C%20high%20detail%20digital%20art&width=1200&height=760&seq=art-read-2026&orientation=landscape',
    content: [
      '追更一部正版韩漫，选对官方入口往往就成功了一半。正版韩漫大全把各官方平台的入口和特点都整理在一起，方便你横向对比、快速上手。',
      '第一步是注册并完成实名或账号绑定。大部分正版平台都支持手机号或第三方账号登录，注册后可开启收藏、订阅与更新提醒功能。',
      '第二步是善用分类与搜索。在平台的恋爱、奇幻、悬疑等分类中浏览，或用关键词精确查找，能找到大量符合你口味的官方正版作品。',
      '第三步是理解付费与试读机制。多数作品提供免费试读章节，后续章节可单话购买或开通会员，在官方渠道付费，作者才能获得合理分成。',
      '最后，记得开启更新推送。正版平台会第一时间提醒你喜欢的作品上新，配合正版韩漫大全的官方入口导航，整个追更体验会顺畅很多。',
    ],
  },
  {
    id: 'a3',
    slug: 'romance-recommendation',
    title: '人气恋爱题材韩漫推荐清单',
    summary: '收录多部高口碑正版恋爱韩漫，无论你是心动少女还是都市白领，都能找到合口味的那一部。',
    category: '精选推荐',
    categorySlug: 'recommend',
    tag: '人气作品',
    date: '2026.07.28',
    readTime: '7 分钟',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20Korean%20webtoon%20illustration%20of%20a%20romantic%20scene%20with%20two%20people%20under%20umbrella%20in%20spring%20rain%2C%20pink%20and%20cream%20warm%20palette%2C%20clean%20manga%20lineart%2C%20romantic%20atmosphere%2C%20high%20detail%20digital%20art&width=1200&height=760&seq=art-romance-2026&orientation=landscape',
    content: [
      '恋爱题材一直是韩漫中最受欢迎的品类之一，细腻的情感刻画与唯美的画面让无数读者入坑。本文为你整理了几部在官方正版渠道上口碑不俗的作品方向。',
      '校园恋爱类：适合喜欢青春悸动的读者，故事围绕教室、社团与初恋情愫展开，画风清新，代入感强。',
      '都市职场类：把成年人的暧昧与心动放进职场背景，剧情更成熟，人物关系也更复杂，适合喜欢成人向恋爱故事的读者。',
      '穿越与契约类：近年大热，女主穿越或契约结婚的设定屡见不鲜，反转与甜宠并存，追起来非常过瘾。',
      '以上作品都能在正版韩漫大全收录的官方平台中找到，记得认准正版渠道，让每一份喜欢都转化为对创作者的支持。',
    ],
  },
  {
    id: 'a4',
    slug: 'fantasy-beginners-guide',
    title: '奇幻冒险类韩漫入门指南',
    summary: '异世界、魔法、剑与龙——为奇幻冒险新读者准备的一份选漫与追更速查手册。',
    category: '精选推荐',
    categorySlug: 'recommend',
    tag: '新手入门',
    date: '2026.07.15',
    readTime: '6 分钟',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20Korean%20webtoon%20illustration%20of%20a%20dragon%20silhouette%20over%20a%20magical%20castle%20with%20stars%2C%20gold%20and%20teal%20palette%2C%20epic%20fantasy%20atmosphere%2C%20clean%20manga%20lineart%2C%20high%20detail%20digital%20art&width=1200&height=760&seq=art-fantasy-2026&orientation=landscape',
    content: [
      '奇幻冒险类韩漫用宏大的世界观和酣畅的战斗征服了无数读者。如果你正准备入坑，这份指南能帮你少走弯路。',
      '从轻度作品入手：建议先从世界观相对简单、节奏明快的冒险故事开始，逐步熟悉剑与魔法、等级与转职等常见设定。',
      '关注人气作家：奇幻领域的头部作者往往拥有稳定的剧情把控能力，其作品在官方正版平台的评分和热度都很可观。',
      '善用正版平台的“完结”筛选：对于不喜欢追更等待的读者，直接筛选已完结作品，一次看个痛快，体验更好。',
      '在正版韩漫大全的奇幻分类中，我们汇总了官方平台上的高人气奇幻作品入口，帮你快速找到属于自己的冒险起点。',
    ],
  },
  {
    id: 'a5',
    slug: 'quick-find-on-official',
    title: '新用户如何快速找到想看的韩漫',
    summary: '想看的作品总是找不到？学会这几招，在官方正版平台里精准定位心仪的韩漫。',
    category: '使用技巧',
    categorySlug: 'tips',
    tag: '使用技巧',
    date: '2026.06.30',
    readTime: '5 分钟',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20Korean%20webtoon%20illustration%20of%20a%20person%20searching%20comic%20shelf%20with%20a%20spotlight%2C%20coral%20and%20cream%20palette%2C%20exploration%20atmosphere%2C%20clean%20manga%20lineart%2C%20high%20detail%20digital%20art&width=1200&height=760&seq=art-find-2026&orientation=landscape',
    content: [
      '面对浩如烟海的韩漫，很多新读者会在“找什么”上花掉大量时间。掌握方法，你就能在官方正版平台快速找到想看的作品。',
      '方法一：关键词直搜。用作品名、角色名甚至题材关键词（如“重生”“穿越”“契约”）搜索，往往能一击命中。',
      '方法二：按榜单浏览。正版平台的热门榜、人气榜与分类榜是发现好作品最快的方式，榜单数据也更能反映作品口碑。',
      '方法三：从收藏夹与相似推荐入手。关注几位风格相近的收藏者，或利用“喜欢这部的人也喜欢”的推荐逻辑，能持续挖掘宝藏。',
      '正版韩漫大全把各官方入口与分类整理成聚合页，从这里出发，再结合上述技巧，找漫会变得又快又准。',
    ],
  },
  {
    id: 'a6',
    slug: 'copyright-what-you-should-know',
    title: '关于韩漫版权，读者应该知道的几件事',
    summary: '版权不只是作者的事，也关乎每位读者。了解这些版权常识，做一名尊重创作的正版读者。',
    category: '行业观察',
    categorySlug: 'insight',
    tag: '版权科普',
    date: '2026.06.18',
    readTime: '8 分钟',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20Korean%20webtoon%20illustration%20of%20a%20shield%20with%20copyright%20symbol%20surrounded%20by%20comic%20pages%2C%20amber%20and%20teal%20palette%2C%20protective%20informative%20atmosphere%2C%20clean%20manga%20lineart%2C%20high%20detail%20digital%20art&width=1200&height=760&seq=art-copyright-2026&orientation=landscape',
    content: [
      '韩漫版权问题近年来备受关注。了解版权常识，能帮助你做出更理性的消费与阅读选择，也是创作者生态健康运转的基石。',
      '首先，正版授权的核心是授权关系。一部韩漫只有在获得作者或版权方明确授权后，才能在特定地区、以特定形式发布，这就是“正版韩漫大全”这类聚合站只收录授权渠道的原因。',
      '其次，付费意味着支持。在官方渠道付费购买或开通会员，收益会按一定比例分配给作者与平台，直接激励创作者持续产出好作品。',
      '再者，盗版会损害创作生态。盗版站既未获得授权，也常夹杂恶意广告与数据风险，读者不仅可能看错版本，还可能面临隐私与安全问题。',
      '最后，养成查询授权的习惯。不确定一部作品是否正版时，多花一分钟确认授权来源，是每一位成熟读者应有的素养，也让整个行业走得更远。',
    ],
  },
];

export const findArticle = (slug: string): Article | undefined =>
  articles.find((a) => a.slug === slug);

export const relatedArticles = (current: Article, count = 3): Article[] => {
  const rest = articles.filter((a) => a.id !== current.id);
  const sameCat = rest.filter((a) => a.category === current.category);
  const pool = sameCat.length >= count ? sameCat : rest;
  return pool.slice(0, count);
};